<template>
    <div v-if="loading" class="preloader" @click.stop.prevent="">
        <div class="preloader__content">
            <div class="lds-dual-ring"></div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('loader', ['loading'])
    }
}
</script>
